/* en cas de réutilisation: (plugin pour générer un toogle button dans vuejs):
Vue.use(ToggleButton);
*/
// This function enables to interpolate data into strings
//https://stackoverflow.com/questions/29182244/convert-a-string-to-a-template-string
// warning: do not use reserved words for functions because otherwise "names" will not work.
//example: we had created an "export" (reserved word) function in component-actions-mixin that was in the list of "names" and caused a bug in the interpolate function

String.prototype.interpolate = function(params) {
  const names = Object.keys(params);
  const vals = Object.values(params);
  return new Function(...names, `return \`${this}\`;`)(...vals);
};

export default {
  xah_range: (min, max, step = 1) =>
    Array(Math.floor((max - min) / step) + 1)
      .fill(min)
      .map((x, i) => x + (i * 100 * step) / 100)
};
// multiply per cent because of float decimal store error by javascript => https://modernweb.com/what-every-javascript-developer-should-know-about-floating-points/
